import arrow from './arrow.png';
import Bed_Clothes from './Bed_Clothes.png';
import bottom_logo from './bottom_logo.png';
import custom_order from './custom_order.png';
import Customizable_tshirts from './Customizable_tshirts.png';
import FABRIC from './FABRIC.png';
import HERO_IMAGE from './HERO_IMAGE.png';
import Ladies_Casual_Wear from './Ladies_Casual_Wear.png';
import Ladies_Fashion_Wear from './Ladies_Fashion_Wear.png';
import Ladies_Home_Wear from './Ladies_Home_Wear.png';
import location from './location.png';
import Note_the_Model_No from './Note_the_Model_No.png';
import Review_Our_Portfolio from './Review_Our_Portfolio.png';
import ROAD_MAP from './ROAD_MAP.png';
import School_Uniforms from './School_Uniforms.png';
import Send_us_the_model_numbers_and_quantity_via_WhatsApp from './Send_us_the_model_numbers_and_quantity_via_WhatsApp.png';
import top_logo from './top_logo.png';
import whatsapp_logo from './whatsapp_logo.png';
import whatsapp_order from './whatsapp_order.png';
import menu from './menu.png';
import cross from './cross.png';
import middle from './middle.png';
import product from './product.png';
import Stitches from './Stitches.jpg';
import Embroidery_work from './Embroidery_work.jpg';
import Customer_Satisfaction from './Customer_Satisfaction.jpg';
import add_to_cart from './add_to_cart.jpg';
import Blouse from './Blouse.png';
import Casualware from './Casualware.png';
import Houseware from './Houseware.png';
import Tops from './Tops.png';

export const assets = {
  arrow,
  Bed_Clothes,
  bottom_logo,
  custom_order,
  Customizable_tshirts,
  FABRIC,
  HERO_IMAGE,
  Ladies_Casual_Wear,
  Ladies_Fashion_Wear,
  Ladies_Home_Wear,
  location,
  Note_the_Model_No,
  Review_Our_Portfolio,
  ROAD_MAP,
  School_Uniforms,
  Send_us_the_model_numbers_and_quantity_via_WhatsApp,
  top_logo,
  whatsapp_logo,
  whatsapp_order,
  menu,
  cross,
  middle,
  product,
  Stitches,
  Embroidery_work,
  Customer_Satisfaction,
  add_to_cart,
  Blouse,
  Casualware,
  Houseware,
  Tops,
};
